app.service('scroll', function (console, html, broker) {
	let $header;
	broker.on('PAGE_CHANGE', function(){
		$header = null;
	})
	function animate(top, speed){
		$("html, body").animate({
			scrollTop: top
		}, speed);
	}
	function calculate(params) {
		
		let $element = $(params.$element).first();
		let speed = params.speed || 300;
		let offsetHeader = 0;						// offset wynikający z samej belki nagówkowej
		let offsetTop = params.offsetTop || 0;		//offsetTop jest deklarowanyc przez wywołanie, dodaję dodatkowy ffset
		let offset = parseInt($element.offset().top);			// to jest wyliczony offset elementu 


		if (params.offsetTop === 'center') {
			offset = - window.innerHeight / 2 + params.$element.height() / 2;
			console.log('Przesunięcie elementu na środek', params);
			animate(offsetTop + offset, speed);
		} else {
			
			if(!$header){
				$header = $('#header, #header-native-app');
			}

			if($header.length && html.has('sticky-header')){			// sprawdzam czy jest sticky header jest dostępny
				if(html.has('sticky-header-pinned')){					// sprawdzam czy jest przypięty
					offsetHeader += parseInt($header.height()) || 0;
					offsetHeader += parseFloat($header.css('top')) || 0;
				} else {												// w tym momencie jest na górze strony
					offsetHeader += parseInt($header.height()) || 0;
					// offsetTop += parseFloat($header.css('top')) || 0;
				}
			}

			console.log('Przesunięcie elementu do ' + offset + ' + ' + offsetHeader + ' + ' + offsetTop );
			animate(offset - offsetHeader - offsetTop, speed);
		}
	}
	function to(params) {
		if (params) {
			if (params.$element && params.$element.length) {
				calculate(params);
			} else {
				console.log('nie ma elementu do skrolowania')
			}
		}
	}
	return {
		to
	};
});
